import React from 'react';

import PageHeader from '../../presentation/layout/PageHeader/PageHeader';
import { MainContainer } from '../../styles/styles';
import { useI18n } from '../../hooks/useI18n';
import { TranslationKeys } from '../../i18n/locales/defaultResources';

const UnauthenticatedHome: React.FC = () => {
  const { t } = useI18n();

  return (
    <MainContainer>
      <PageHeader title={t(TranslationKeys.unauthoricated_home_welcome)} />
      <p>{t(TranslationKeys.unauthoricated_home_prompt)}</p>
    </MainContainer>
  );
};

export default UnauthenticatedHome;
